import React from 'react';
import ContentLoader from 'react-content-loader';

const genericSkel = <ContentLoader
    speed={1}
    width="100%"
    height="100%"
    viewBox="0 0 400 250"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="5%" y="5%" rx="0" ry="0" width="90%" height="90%" />

</ContentLoader>

const genericVerticalSkel = <ContentLoader
    speed={1}
    width="100%"
    height="100%"
    viewBox="0 0 350 100"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="5%" y="5%" rx="0" ry="0" width="90%" height="90%" />

</ContentLoader>

const verticalSkel = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 350 100"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="30" y="25" rx="0" ry="0" width="20%" height="8" />
    <rect x="10%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="30%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="50%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="70%" y="45" rx="0" ry="0" width="18%" height="40" />
</ContentLoader>

const navbarSkeletonVertical = <ContentLoader
    speed={2}
    width="100%"
    height="40"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    {/* <rect x="0%" y="0%" rx="0" ry="0" width="13%" height="100%" /> */}
    {/* <rect x="16%" y="5%" rx="0" ry="0" width="13%" height="80%" /> */}
    <rect x="0%" y="5%" rx="0" ry="0" width="13%" height="80%" />
    <rect x="16%" y="5%" rx="0" ry="0" width="13%" height="80%" />
    <rect x="32%" y="5%" rx="0" ry="0" width="13%" height="80%" />
    {/* <circle cx="97%" cy="50%" rx="0" ry="0" r="20" /> */}
</ContentLoader>

const declarationSummarySkel = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 400 250"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="3" />
    <rect x="40" y="35" rx="0" ry="0" width="30%" height="15" />
    <rect x="10%" y="60" rx="0" ry="0" width="40%" height="30%" />
    <rect x="55%" y="60" rx="0" ry="0" width="40%" height="15%" />
    <rect x="10%" y="140" rx="0" ry="0" width="40%" height="25%" />
    <rect x="55%" y="40%" rx="0" ry="0" width="40%" height="25%" />
    <rect x="40" y="90%" rx="0" ry="0" width="15%" height="8%" />
    <rect x="80%" y="90%" rx="0" ry="0" width="15%" height="8%" />
</ContentLoader>
const damagedGoodCirconstances = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 400 250"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="3" />
    <rect x="40" y="35" rx="0" ry="0" width="25%" height="10" />
    <rect x="40" y="55" rx="0" ry="0" width="60%" height="5" />
    <rect x="40" y="25%" rx="0" ry="0" width="80%" height="50%" />
    <rect x="40" y="80%" rx="0" ry="0" width="25%" height="10" />
    <rect x="40" y="90%" rx="0" ry="0" width="15%" height="8%" />
    <rect x="80%" y="90%" rx="0" ry="0" width="15%" height="8%" />
</ContentLoader>
const supportingDocSkel = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 500 180"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="3" />
    <rect x="40" y="35" rx="0" ry="0" width="20%" height="15" />
    <rect x="40" y="40%" rx="0" ry="0" width="80%" height="10" />
    <rect x="45" y="50%" rx="0" ry="0" width="80%" height="30" />
    <rect x="40" y="80%" rx="0" ry="0" width="15%" height="12%" />
    <rect x="80%" y="80%" rx="0" ry="0" width="15%" height="12%" />
</ContentLoader>
const coverSelectionSkel = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 350 200"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="3" />
    <rect x="30" y="25" rx="0" ry="0" width="20%" height="8" />
    <rect x="10%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="30%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="50%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="30" y="100" rx="0" ry="0" width="20%" height="8" />
    <rect x="10%" y="120" rx="0" ry="0" width="18%" height="40" />
    <rect x="30%" y="120" rx="0" ry="0" width="18%" height="40" />
    <rect x="50%" y="120" rx="0" ry="0" width="18%" height="40" />
    <rect x="70%" y="90%" rx="0" ry="0" width="15%" height="10%" />
</ContentLoader>
const properFunctioningConfirmationSkel = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 350 200"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="3" />
    <rect x="30" y="25" rx="0" ry="0" width="40%" height="8" />
    <rect x="10%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="30%" y="45" rx="0" ry="0" width="18%" height="40" />
    <rect x="30" y="100" rx="0" ry="0" width="40%" height="12" />
    <rect x="10%" y="120" rx="0" ry="0" width="18%" height="40" />
    <rect x="30%" y="120" rx="0" ry="0" width="18%" height="40" />
    <rect x="50%" y="120" rx="0" ry="0" width="18%" height="40" />
    <rect x="30" y="90%" rx="0" ry="0" width="15%" height="10%" />
    <rect x="70%" y="90%" rx="0" ry="0" width="15%" height="10%" />
</ContentLoader>
const claimLocationSkel = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 400 180"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="3" />
    <rect x="40" y="35" rx="0" ry="0" width="40%" height="10" />
    <rect x="45" y="60" rx="0" ry="0" width="17%" height="30%" />
    <rect x="120" y="60" rx="0" ry="0" width="17%" height="30%" />
    <rect x="195" y="60" rx="0" ry="0" width="17%" height="30%" />
    <rect x="40" y="80%" rx="0" ry="0" width="15%" height="12%" />
    <rect x="70%" y="80%" rx="0" ry="0" width="15%" height="12%" />
</ContentLoader>
const registredStatementSkel = <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox="0 0 450 180"
    backgroundColor="#ababab"
>
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="3" />
    <rect x="10%" y="20%" rx="0" ry="0" width="20%" height="10" />
    <circle cx="50%" cy="40%" r="20" />
    <rect x="25%" y="60%" rx="0" ry="0" width="50%" height="3%" />
    <rect x="30%" y="70%" rx="0" ry="0" width="40%" height="3%" />
    <rect x="25%" y="80%" rx="0" ry="0" width="50%" height="3%" />
    <rect x="40%" y="90%" rx="0" ry="0" width="20%" height="10%" />
</ContentLoader>

const footerSkel = <ContentLoader
    speed={2}
    width="100%"
    height="50"
    backgroundColor="#ababab"
    foregroundColor="#fafafa"
>
    <rect x="25%" y="25%" rx="0" ry="0" width="3%" height="50%" />
    <rect x="30%" y="25%" rx="0" ry="0" width="8%" height="50%" />
    <rect x="40%" y="25%" rx="0" ry="0" width="8%" height="50%" />
    <rect x="50%" y="25%" rx="0" ry="0" width="8%" height="50%" />
    <rect x="60%" y="25%" rx="0" ry="0" width="8%" height="50%" />

</ContentLoader>

export const associativeSkelMap = new Map<string, any>([
    ['genericSkel', genericSkel],
    ['verticalSkel', verticalSkel],
    ['coverSelection', coverSelectionSkel],
    ['damagedGoodProperFunctioningConfirmation', properFunctioningConfirmationSkel],
    ['claimLocation', claimLocationSkel],
    ['supportingDocuments', supportingDocSkel],
    ['damagedGoodCirconstances', damagedGoodCirconstances],
    ['declarationSummary', declarationSummarySkel],
    ['registeredStatement', registredStatementSkel],
    ['navbarSkeletonVertical', navbarSkeletonVertical],
    ['genericVerticalSkel', genericVerticalSkel],
    ['footerSkel', footerSkel]
]);